<app-wizard-step-wrapper
  [showStep]="showStep"
  [stepTitle]="stepTitle$ | async"
  [formGroup]="formStep"
  >
  @if (showStep || stepHasBeenShown) {
    @switch (signatureType$ | async) {
      @case (SignatureTypeEnum.Drawn) {
        <app-draw-signature-step
          [user]="user"
          (stepComplete)="goToNextStep()"
        ></app-draw-signature-step>
      }
      @case (SignatureTypeEnum.Selected) {
        <app-select-signature
          [user]="user"
          (stepComplete)="goToNextStep()"
        ></app-select-signature>
      }
      @case (SignatureTypeEnum.Uploaded) {
        <app-acknowledge-uploaded-signature
          [user]="user"
          (stepComplete)="goToNextStep()"
        ></app-acknowledge-uploaded-signature>
      }
    }
  }
</app-wizard-step-wrapper>
